import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header-simple',
  templateUrl: './header-simple.component.html',
  styleUrl: './header-simple.component.scss',
})
export class HeaderSimpleComponent {
  @Input()
  title: string = '';

  @Input()
  routerGoBack: string = '';

  @Input()
  showBtnBack: boolean = false;

  @Input()
  isModal: boolean = false;

  @Output()
  public evtGoBack: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private router: Router) {}

  onClick() {
    this.evtGoBack.emit(true);
    if (!this.isModal) {
      this.router.navigate([this.routerGoBack]);
    }
  }
}
